import { useCallback, useEffect, useMemo } from "react";
import { useQueryLoader, useRelayEnvironment } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import { WA_CATEGORY_NOTE_PREVIEWS_QUERY } from "./WACategoryNotePreviews";
import {
  WACategoryNotePreviewsQuery,
  WACategoryNotePreviewsQuery$rawResponse,
  WACategoryNotePreviewsQuery$variables,
} from "./__generated__/WACategoryNotePreviewsQuery.graphql";
import {
  useMockPreviewWidgetNoteImageSlideshow,
  useMockPreviewWidgetNoteDailyPositive,
  useMockPreviewWidgetNoteEmpty,
} from "./getWidgetNoteMockPreview";

const dummyInput = (index: number, DATA_PREFIX: string) => ({
  id: DATA_PREFIX + index,
  pages: [],
  size: "TWO_X_TWO",
  storecastId: "",
  title: "",
});

export function useWACategoryNotePreviewsQueryLoader(
  DATA_PREFIX: string = "WA_CATEGORY_NOTE_PREVIEWS_QUERY:"
) {
  const env = useRelayEnvironment();
  const vars = useMemo(
    () =>
      ({
        storecastId: "dummyId",
        input1: dummyInput(1, DATA_PREFIX),
        input2: dummyInput(2, DATA_PREFIX),
        input3: dummyInput(3, DATA_PREFIX),
      }) as WACategoryNotePreviewsQuery$variables,
    [DATA_PREFIX]
  );

  const [queryRef, load] = useQueryLoader<WACategoryNotePreviewsQuery>(
    WA_CATEGORY_NOTE_PREVIEWS_QUERY
  );

  const empty = useMockPreviewWidgetNoteEmpty({
    dataPrefix: DATA_PREFIX + "0",
  });

  const dp = useMockPreviewWidgetNoteDailyPositive({
    dataPrefix: DATA_PREFIX + "1",
  });
  const slide = useMockPreviewWidgetNoteImageSlideshow({
    dataPrefix: DATA_PREFIX + "2",
  });

  const populateData = useCallback(() => {
    const req = getRequest(WA_CATEGORY_NOTE_PREVIEWS_QUERY);
    const op = createOperationDescriptor(req, vars);

    const payload: WACategoryNotePreviewsQuery$rawResponse = {
      dashboard: {
        id: vars.storecastId,
        previewWidgetNote1: empty,
        previewWidgetNote2: dp,
        previewWidgetNote3: slide,
      },
    };
    env.commitPayload(op, payload);
    load(vars);
  }, [dp, empty, env, load, slide, vars]);

  useEffect(() => populateData(), [populateData]);

  return queryRef;
}
